
const prod = {
    url: {
        APP_ENV: 'prod',
        PAYMENT_AMOUNT: 2000,
        STU_URL: 'https://api.studentmigration.apcfss.in/studentmigration/',//PROD
        FILE_DOWNLOAD_URL: "https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/bucket/affiliation-documents/",
        FILE_UPLOAD_URL: 'https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-upload/bucket/affiliation-documents/affiliation/',

    }
};
const protocol = window.location.protocol === "https:" ? "https" : "http";
const dev = {
    url: {
        APP_ENV: 'dev',
        PAYMENT_AMOUNT: 1,
        STU_URL: 'https://swapi.dev.nidhi.apcfss.in/studentmigration/', //DEV

        FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,


    }
};

const local = {
    url: {
        APP_ENV: 'local',
        PAYMENT_AMOUNT: 1,
        // STU_URL: `${protocol}://172.16.119.243:8001/studentmigration/`, //Pavani  /
        STU_URL: `${protocol}://172.16.119.131:8001/studentmigration/`, //Srinu  /
        // STU_URL: 'https://swapi.dev.nidhi.apcfss.in/studentmigration/',
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,
        FILE_DOWNLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/`,

    }

};


export const config = process.env.NODE_ENV === 'development' ? dev : prod;